import React from "react";
import { FlatList, StyleSheet, View } from "react-native";
import S3Image from "screens/common/S3Image";
import SClickableArea from "styled42/components/SClickableArea";
import SText from "styled42/components/SText";
import { Colors } from "styled42/config";

const SelectedFAList = ({ selectedFAList, onDelete }) => {
  if (selectedFAList.length < 1) {
    return null;
  }

  return (
    <View style={styles.container}>
      <FlatList
        data-hide-scrollbar
        horizontal
        showsHorizontalScrollIndicator={false}
        extraData={selectedFAList}
        data={selectedFAList}
        keyExtractor={(item) => `selected-list-${item.id}`}
        renderItem={({ item, index }) => {
          return (
            <View style={styles.faItemContainer}>
              <SText size={12} weight="500">
                {item.name}
              </SText>
              <SClickableArea
                containerStyle={styles.deleteButton}
                onClick={() => {
                  onDelete(index);
                }}
              >
                <View style={[styles.selectedContainer, styles.crossContainer]}>
                  <View style={[styles.cross, styles.rotate45]}>
                    <View style={[styles.cross, styles.rotate90]} />
                  </View>
                </View>
              </SClickableArea>
            </View>
          );
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 16
  },
  crossContainer: {
    backgroundColor: Colors.Orange[4],
    right: 0,
    top: 0
  },

  cross: {
    height: 8,
    width: 1,
    borderColor: "#E9E9E9",
    borderRightWidth: 2
  },
  rotate45: {
    transform: [{ rotate: "45deg" }]
  },
  rotate90: {
    transform: [{ rotate: "90deg" }]
  },
  selectedContainer: {
    // position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    width: 14,
    height: 14,
    borderRadius: 14,
    zIndex: 2
  },
  faItemContainer: {
    height: 28,
    marginRight: 16,
    paddingLeft: 8,
    paddingRight: 4,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFF3E8",
    borderWidth: 1,
    borderColor: "#FF9518",
    borderRadius: 20
  },
  crossIcon: {
    height: 24,
    width: 24
  },
  deleteButton: {
    marginLeft: 4
  }
});

export default SelectedFAList;
